
const SECTIONS = window.SCRUBBER_SECTIONS || [];
const WHATSAPP_NUM = window.SCRUBBER_WHATSAPP || '573042351528';
const N = SECTIONS.length;

const bgVideos = Array.from(document.querySelectorAll('.sc-bg-video'));
let currentSection = 0;
let raf = null;

// iOS/Safari no "pinta" ningún fotograma de un <video> que nunca se ha reproducido,
// aunque le cambies currentTime manualmente. Por eso hacemos un play+pause instantáneo
// (mudo, sin sonido) para forzar el primer dibujado y cada vez que cambiamos el fotograma.
function nudge(v) {
  if (!v) return;
  var p = v.play();
  if (p && typeof p.then === 'function') {
    p.then(function () { v.pause(); }).catch(function () {});
  } else {
    v.pause();
  }
}

function activateVideo(idx) {
  bgVideos.forEach((v, i) => {
    if (i === idx) {
      v.classList.add('on');
      if (v.preload === 'none') { v.preload = 'auto'; v.load(); }
      nudge(v); // pinta el primer fotograma de esta sección de inmediato
    } else {
      v.classList.remove('on');
      if (!v.paused) v.pause();
    }
  });
  // precarga los 2 vecinos siguientes (no solo 1) para dar más margen en redes móviles lentas
  [bgVideos[idx + 1], bgVideos[idx + 2]].forEach(function(v){
    if (v && v.preload !== 'auto') { v.preload = 'auto'; v.load(); }
  });
}

// Mueve el fotograma del video activo según el progreso de scroll dentro de su sección.
function scrubVideo(idx, sectionProgress) {
  const v = bgVideos[idx];
  if (!v) return;
  if (v.readyState >= 1 && v.duration && !isNaN(v.duration)) {
    const target = Math.min(v.duration - 0.05, Math.max(0, sectionProgress * v.duration));
    if (Math.abs(v.currentTime - target) > 0.04) {
      v.currentTime = target;
      nudge(v); // sin esto, iOS deja el frame anterior pintado (o en negro)
    } else if (v.paused === false) {
      v.pause();
    }
  }
}

// Build dots
const dotsEl = document.getElementById('sec-counter');
if (dotsEl) {
  SECTIONS.forEach((s,i) => {
    const d = document.createElement('button');
    d.className = 'sc-dot' + (i===0?' on':'');
    d.onclick = () => scrollToSection(i);
    dotsEl.appendChild(d);
  });
}

function scrollToSection(idx) {
  const scrubber = document.getElementById('scrubber');
  const sectionH = scrubber.offsetHeight / N;
  window.scrollTo({ top: scrubber.offsetTop + sectionH * idx + 1, behavior: 'smooth' });
}

// Tarjeta grande con la imagen/video de la sección actual. Aparece y desaparece
// junto con el scroll (sin pausarlo, sin botón Continuar).
const infoCard = document.getElementById('info-card');
let infoShownFor = -1;

function showInfo(idx) {
  if (!infoCard) return;
  const s = SECTIONS[idx];
  if (!s || s.is_hero) { hideInfo(); return; }
  if (infoShownFor === idx) return;
  infoShownFor = idx;

  const media = document.getElementById('ic-media');
  if (media) {
    media.innerHTML = '';
    if (s.media_type === 'video' && s.media_url) {
      const v = document.createElement('video');
      v.src = s.media_url; v.muted = true; v.loop = true; v.playsInline = true; v.autoplay = true;
      media.appendChild(v);
      media.style.display = 'block';
      nudge(v);
    } else if (s.media_type === 'image' && s.media_url) {
      const img = document.createElement('img');
      img.src = s.media_url;
      media.appendChild(img);
      media.style.display = 'block';
    } else {
      media.style.display = 'none';
    }
  }
  const tagEl = document.getElementById('ic-tag'); if (tagEl) tagEl.textContent = s.tag || '';
  const titleEl = document.getElementById('ic-title'); if (titleEl) titleEl.innerHTML = s.title || '';
  const descEl = document.getElementById('ic-desc'); if (descEl) descEl.textContent = s.desc || '';
  const pillsEl = document.getElementById('ic-pills');
  if (pillsEl) {
    pillsEl.innerHTML = '';
    (s.pills || []).forEach(p => {
      if (!p) return;
      const span = document.createElement('span');
      span.className = 'ic-pill'; span.textContent = p;
      pillsEl.appendChild(span);
    });
  }
  const waEl = document.getElementById('ic-wa');
  if (waEl) {
    waEl.textContent = s.wa_texto || 'Cotizar este servicio';
    waEl.href = 'https://wa.me/' + WHATSAPP_NUM + '?text=' + encodeURIComponent(s.wa_mensaje || '');
  }
  infoCard.classList.add('show');
}

function hideInfo() {
  infoShownFor = -1;
  if (infoCard) infoCard.classList.remove('show');
}

function updateScrubber() {
  const scrubber = document.getElementById('scrubber');
  if (!scrubber) return;
  const scrubberTop = scrubber.offsetTop;
  const scrubberH = scrubber.offsetHeight;
  const winH = window.innerHeight;
  const scrolled = window.scrollY - scrubberTop;
  const maxScroll = scrubberH - winH;
  const progress = Math.max(0, Math.min(1, scrolled / maxScroll));

  // Ya salimos por completo del scrubber (estamos en servicios/galería/etc).
  // Ocultar los paneles para que no queden flotando sobre el resto de la página.
  if (scrolled >= maxScroll) {
    document.querySelectorAll('.sc-panel').forEach((p) => {
      p.classList.remove('on');
      p.style.opacity = '';
      p.style.pointerEvents = 'none';
    });
    hideInfo();
    const sh0 = document.getElementById('scroll-hint');
    if (sh0) sh0.style.opacity = '0';
    const navEl0 = document.getElementById('nav');
    if (navEl0) navEl0.classList.toggle('solid', window.scrollY > 60);
    const pageH0 = document.documentElement.scrollHeight - window.innerHeight;
    const progEl0 = document.getElementById('prog');
    if (progEl0 && pageH0 > 0) progEl0.style.width = (window.scrollY / pageH0 * 100) + '%';
    const sp0 = document.getElementById('scrub-prog');
    if (sp0) sp0.style.width = '100%';
    return;
  }

  const rawIdx = progress * N;
  const sIdx = Math.min(N - 1, Math.floor(rawIdx));
  const sectionProgress = rawIdx - sIdx;

  // SECTION CHANGE — crossfade al video propio de la sección
  if (sIdx !== currentSection) {
    currentSection = sIdx;
    activateVideo(sIdx);
  }

  // Mostrar la tarjeta grande con la imagen/video de la sección actual
  // (aparece/desaparece sola con el scroll, no pausa nada)
  if (sectionProgress > 0.08 && sectionProgress < 0.92) {
    showInfo(sIdx);
  } else {
    hideInfo();
  }

  // Mover el fotograma del video activo según el scroll (sin reproducir solo)
  scrubVideo(sIdx, sectionProgress);

  // Update dots
  document.querySelectorAll('.sc-dot').forEach((d,i) => d.classList.toggle('on', i===sIdx));

  // Update panels: mostrar solo el de la sección actual (cada categoría se ve una sola vez)
  document.querySelectorAll('.sc-panel').forEach((p,i) => {
    if (i === sIdx) {
      p.classList.add('on');
      p.style.opacity = '1';
      p.style.pointerEvents = 'all';
    } else {
      p.classList.remove('on');
      p.style.opacity = '';
      p.style.pointerEvents = 'none';
    }
  });

  // UI
  const sh = document.getElementById('scroll-hint');
  if (sh) sh.style.opacity = progress < 0.015 ? '1' : '0';
  document.getElementById('nav').classList.toggle('solid', window.scrollY > 60);
  const pageH = document.documentElement.scrollHeight - window.innerHeight;
  if (pageH > 0) document.getElementById('prog').style.width = (window.scrollY / pageH * 100) + '%';
  const sp = document.getElementById('scrub-prog');
  if (sp) sp.style.width = (progress * 100) + '%';
}

window.addEventListener('scroll', () => {
  if (raf) cancelAnimationFrame(raf);
  raf = requestAnimationFrame(updateScrubber);
}, { passive: true });

// Initialize: forzar panel 0 activo
document.querySelectorAll('.sc-panel').forEach((p,i) => {
  if (i === 0) {
    p.classList.add('on');
    p.style.pointerEvents = 'all';
  } else {
    p.classList.remove('on');
    p.style.pointerEvents = 'none';
  }
});
document.querySelectorAll('.sc-dot').forEach((d,i) => d.classList.toggle('on', i===0));
activateVideo(0);
// Reintenta el "nudge" cuando el primer video ya tenga datos suficientes
// (en celulares puede tardar un poco en cargar metadata).
if (bgVideos[0]) {
  bgVideos[0].addEventListener('loadeddata', function(){ nudge(bgVideos[0]); }, { once: true });
  bgVideos[0].addEventListener('canplay', function(){ nudge(bgVideos[0]); }, { once: true });
}

updateScrubber();

// Reveal secciones (servicios, galería, contacto)
const obs = new IntersectionObserver((entries) => {
  entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('on'); obs.unobserve(e.target); } });
}, { threshold: 0.1 });
document.querySelectorAll('.rv').forEach(el => obs.observe(el));

// Año footer
const yr = document.getElementById('yr');
if (yr) yr.textContent = new Date().getFullYear();

// Formulario WhatsApp
const qf = document.getElementById('qf');
if (qf) qf.addEventListener('submit', e => {
  e.preventDefault();
  const n = document.getElementById('fn').value;
  const t = document.getElementById('ft').value;
  const s = document.getElementById('fs').value;
  const st = document.getElementById('fst') ? document.getElementById('fst').value : '';
  const m = document.getElementById('fm').value;
  const msg = 'Hola! Soy ' + n + ' (' + t + '). Me interesa: ' + s + (st ? ', estilo ' + st : '') + (m ? '. ' + m : '');
  window.open('https://wa.me/573042351528?text=' + encodeURIComponent(msg), '_blank');
});



(function(){
  // Stats counter
  function easeOut(t){return t===1?1:1-Math.pow(2,-10*t)}
  function animateCount(el){
    var from=parseInt(el.dataset.from)||0,to=parseInt(el.dataset.target),dur=parseInt(el.dataset.duration)||1200,start=null;
    (function step(ts){if(!start)start=ts;var p=Math.min((ts-start)/dur,1);el.textContent=Math.round(from+(to-from)*easeOut(p));if(p<1)requestAnimationFrame(step);else el.textContent=to;})(performance.now());
  }
  var bar=document.getElementById('stats-bar');
  if(bar){var done=false;new IntersectionObserver(function(e){if(e[0].isIntersecting&&!done){done=true;bar.querySelectorAll('.stat-item').forEach(function(i){i.style.opacity='1';i.style.transform='translateY(0)'});bar.querySelectorAll('.stat-label').forEach(function(l){l.style.opacity='1';l.style.transform='translateY(0)'});bar.querySelectorAll('.stat-num').forEach(function(el,i){setTimeout(function(){animateCount(el)},i*150+300)});}},{threshold:.3}).observe(bar);}
  // Portfolio filter
  var btns=document.querySelectorAll('.pf-btn'),items=document.querySelectorAll('.pf-item');
  if(btns.length){btns[0].classList.add('active');btns.forEach(function(btn){btn.addEventListener('click',function(){var cat=this.dataset.cat;btns.forEach(function(b){b.classList.remove('active')});this.classList.add('active');items.forEach(function(item){item.style.display=(cat==='todos'||item.dataset.cat===cat)?'block':'none'});});});}
})();
function sendWA(e){e.preventDefault();var f=document.getElementById('cont-form');var msg="Hola, me interesa cotizar.\n\nNombre: "+f.nombre.value+"\nTeléfono: "+f.tel.value+"\nServicio: "+(f.servicio.value||'Por definir')+"\nDescripción: "+(f.desc.value||'—');window.open("https://wa.me/573042351528?text="+encodeURIComponent(msg),"_blank");return false;}
